import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ShieldCheck(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4956 1.08739C15.8218 0.97087 16.1782 0.97087 16.5044 1.08739L27.0044 4.83739C27.6014 5.05061 28 5.61609 28 6.25001V19.4743C28 22.0263 26.7024 24.4032 24.5557 25.7832L16.8112 30.7618C16.3171 31.0794 15.683 31.0794 15.1888 30.7618L7.44431 25.7832C5.29765 24.4032 4 22.0263 4 19.4743V6.25001C4 5.61609 4.39851 5.05061 4.99549 4.83739L15.4956 1.08739ZM21.5606 14.0607C22.1464 13.4749 22.1464 12.5251 21.5606 11.9393C20.9749 11.3536 20.0251 11.3536 19.4394 11.9393L14.5 16.8787L12.5607 14.9394C11.9749 14.3536 11.0251 14.3536 10.4393 14.9394C9.85355 15.5251 9.85355 16.4749 10.4393 17.0607L13.4394 20.0607C14.0251 20.6464 14.9749 20.6464 15.5606 20.0607L21.5606 14.0607Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
